import { Button, Input, InputWrapperProps, TextInput, TextInputProps } from "@mantine/core";
import { useFormHelperContext } from "../form";
import { useController, useFieldArray } from "react-hook-form";
import { InputWrapper } from "../inputWrapper";
import { IconTrash } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export interface FieldHiddenProps extends TextInputProps {
    name: string;
    inputWrapper?: InputWrapperProps;
}

export const FiledHidden: React.FC<FieldHiddenProps> = ({ label, name, placeholder, inputWrapper, ...rest }) => {
    const { register, control } = useFormHelperContext();
    const { field, fieldState: { error }, } = useController({ name, control });


    if (!register) {
        throw new Error("Field.Hidden must be used within a FormHelper component");
    }

    return (
        <InputWrapper label={""} {...inputWrapper} withAsterisk={rest.withAsterisk} display={'none'}>
            <div className="flex flex-col w-full">
                <TextInput
                    {...field}
                    value={field.value ?? ""}
                    data-testid={'field-hidden-' + name}
                    error={
                        error ? " " : undefined
                    }
                    {...rest}
                />
                {error && (
                    <Input.Error>{error.message}</Input.Error>
                )}
            </div>
        </InputWrapper>

    );
};
